export { ShopSegmentedControl } from './ShopSegmentedControl';
export type { ShopTab, ShopSegmentedControlProps } from './ShopSegmentedControl';
